import { useRef, useEffect, useState } from "react";
import { useInView } from 'react-intersection-observer';
import { Star, Users, Globe, Heart, Droplet, Briefcase } from 'lucide-react';
import './index.css';
import apiData from '../../api';


// A subsidiary of Rose of Jericho Community Development Center

const HomeLayout = () => {
    const { ref: ref1, inView: inView1 } = useInView({ triggerOnce: true, threshold: 0.1 });
    const { ref: ref2, inView: inView2 } = useInView({ triggerOnce: true, threshold: 0.1 });
    const { ref: ref3, inView: inView3 } = useInView({ triggerOnce: true, threshold: 0.1 });
    const { ref: ref4, inView: inView4 } = useInView({ triggerOnce: true, threshold: 0.1 });
    const { ref: ref5, inView: inView5 } = useInView({ triggerOnce: true, threshold: 0.1 });
    const { ref: ref6, inView: inView6 } = useInView({ triggerOnce: true, threshold: 0.1 });


    return (
        <>
            <section className="">
                <div className="flex flex-col md:flex-row  md:space-x-0 space-y-2 md:space-y-0 " >
                    <div className="bg-opacity-70 p-20 pb-0 md:pb-10 md:w-1/2">
                        <h2 className="text-6xl font-thin mb-4 text-tc-gold fonseca_thin md:mt-10">Take the first step toward your transformed self</h2>
                        <p className="text-lg mb-12 mt-6 text-gray-600">
                            The Transformation Collective exists to empower individuals and communities
                            through innovative solutions and transformative leadership, equipping them to create
                            lasting change and sustainable impact in every sphere of society.
                        </p>
                        <a
                            href="#" // TODO: Add Kajabi link
                            className="bg-tc-blue text-white text-tc-blue font-bold px-8 py-4 rounded-lg hover:bg-yellow-400 transition duration-300"
                        >
                            Join our Community
                        </a>
                    </div>

                    <div className="bg-opacity-90 p-20 pb-0 md:pb-10 md:w-1/2 HL_imgSample">
                        <div className='HL_imgSample1' style={{ background: `url(${apiData.imgUri}49506453.jpeg) center`, backgroundSize: "cover", }}></div>
                        <div className='HL_imgSample2'>
                            <div className='bg-tc-gold HL_imgSample2_sub1 bg-gray-600'>
                                <h3 className='fonseca text-white'>Transformation is a form of transition</h3>
                            </div>
                            <div className='HL_imgSample2_sub2' style={{ background: `url(${apiData.imgUri}39191038.jpeg) center`, backgroundSize: "cover", }}></div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Rose of Jericho Connection */}
            <section className="relative bg-gray-900 text-white py-16">
                <div className="absolute inset-0">
                    <img
                        src={`${apiData.imgUri2}rose.jpg`}
                        alt="Community Leadership"
                        className="w-full h-full object-cover opacity-30"
                    />
                </div>

                <div className="relative container mx-auto px-6 md:px-12 flex flex-col items-center text-center">
                    <h2 className="text-3xl md:text-5xl font-bold text-white">
                        A Proud Subsidiary of
                        <span className="text-red-400"> Rose of Jericho</span>
                    </h2>
                    <p className="mt-4 text-lg md:text-xl max-w-4xl text-center">
                        The <strong>Transformation Collective Leadership Training</strong> is an initiative under
                        the <strong>Rose of Jericho Community Development Center</strong>, an organization dedicated to
                        restoring and transforming communities through leadership training, mental health awareness,
                        career development, and holistic well-being programs.
                    </p>
                    <a
                        href="#"
                        className="mt-6 inline-block bg-yellow-500 hover:bg-yellow-600 text-gray-900 font-semibold py-3 px-6 rounded-lg transition duration-300"
                    >
                        Learn More
                    </a>
                </div>
            </section>

            {/* Transformational Leadership Academy */}
            <section
                ref={ref2}
                className={`py-24 bg-gray-50`}
            // style={{opacity: inView2 ? 1 : 0, transform: inView2 ? 'translateY(0)' : 'translateY(10px)', transition: 'opacity 1s ease-in-out, transform 1s ease-in-out'}}
            >
                <div className="max-w-7xl mx-auto px-4">
                    <div className="relative">
                        <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                            <Users className="w-12 h-12 text-brand-600" />
                        </div>
                        <div className="text-center max-w-3xl mx-auto mb-16 pt-8">
                            <h2 className="font-cormorant text-5xl font-bold mb-6">Transformational Leadership Academy</h2>
                            <p className="text-lg text-gray-600">
                                A comprehensive 12-month program tailored for seasoned leaders who aim to drive innovation, foster collaboration, and leave a lasting legacy.
                            </p>
                        </div>
                        <div className="grid md:grid-cols-3 gap-8">
                            {[
                                {
                                    title: "Leadership Mastery Modules",
                                    image: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&q=80"
                                },
                                {
                                    title: "Networking Opportunities",
                                    image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80"
                                },
                                {
                                    title: "Visionary Leadership",
                                    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&q=80"
                                }
                            ].map((item, index) => (
                                <div key={index} className="group relative overflow-hidden rounded-xl">
                                    <img
                                        src={item.image}
                                        alt={item.title}
                                        className="w-full h-80 object-cover transform group-hover:scale-110 transition duration-500"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                                    <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                                        <h3 className="font-cormorant text-2xl font-bold">{item.title}</h3>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="text-center mt-12">
                            <button className="bg-gray-900 text-white px-8 py-4 rounded-lg hover:bg-brand-700 transition-colors">
                                Learn More
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            {/* Business and Ministry Coaching */}
            <section
                ref={ref6}
                className={`py-24 bg-gray-900 bg-gradient-to-r from-tc-blue to-yellow-700 text-white transition-all duration-1000 ${inView6 ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                    }`}
            >

                <video
                    className="w-full h-full object-cover opacity-20 absolute inset-0"
                    autoPlay
                    loop
                    muted
                    playsInline
                    src={`${apiData.imgUri2}businesVid.mp4`}
                />
                <div className="max-w-7xl mx-auto px-4 relative inset-0">
                    <div className="grid lg:grid-cols-2 gap-16 items-center">
                        <div className="space-y-8">
                            <Briefcase className="w-12 h-12 text-brand-400" />
                            <h2 className="font-cormorant text-5xl font-bold">Business and Ministry Coaching</h2>
                            <p className="text-lg text-gray-300">
                                Unlock your potential with our tailored coaching programs. Whether you're scaling a business or building a ministry, we'll help you thrive in your calling.
                            </p>
                            <div className="grid grid-cols-2 gap-6">
                                <div className="space-y-4">
                                    <div className="w-12 h-1 bg-brand-400"></div>
                                    <h3 className="font-cormorant text-xl font-bold">Expert Guidance</h3>
                                    <p className="text-gray-400">Personalized mentorship from industry leaders</p>
                                </div>
                                <div className="space-y-4">
                                    <div className="w-12 h-1 bg-brand-400"></div>
                                    <h3 className="font-cormorant text-xl font-bold">Faith-Based</h3>
                                    <p className="text-gray-400">Principles rooted in spiritual wisdom</p>
                                </div>
                            </div>
                            <button className="bg-tc-gold text-white font-bold px-8 py-4 rounded-lg hover:bg-brand-700 transition-colors">
                                Start Your Journey
                            </button>
                        </div>
                        <div className="relative">
                            <div className="absolute inset-0 bg-brand-400/20 rounded-xl transform rotate-3"></div>
                            <img
                                src="https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&q=80"
                                alt="Business Coaching"
                                className="relative rounded-xl shadow-xl"
                            />
                        </div>
                    </div>
                </div>
            </section>

            {/* Podcasts */}
            <section>
                <div className="mx-auto px-4">
                    <div className="container mx-auto p-4">
                        <div className="mx-auto grid grid-cols-12 gap-0">
                            <div className='col-span-12 md:col-span-4 lg:col-span-5 p-6 flex flex-col justify-center'>
                                <h1 className="font-cormorant text-4xl font-bold fonseca">Tune into podcasts</h1>
                                <p className="text-gray-600">
                                    Don't miss out on our exciting episodes and transformative sessions.
                                    Each podcast is designed to inspire, educate, and empower you with insights
                                    and stories from leaders and change-makers.
                                </p>
                            </div>

                            <div className='col-span-12 md:col-span-8 lg:col-span-7'>
                                <div style={{ height: "100%", display: "flex", flexDirection: "row", alignItems: "center" }}>
                                    {[
                                        { cover: apiData.imgUri2 + "podcast1.jpg", url: "", title: "More about you" },
                                        { cover: apiData.imgUri2 + "podcast2.jpg", url: "", title: "The tramnsformation collective" },
                                        { cover: apiData.imgUri2 + "podcast3.jpg", url: "", title: "Time to grow" },
                                        { cover: apiData.imgUri2 + "podcast1.jpg", url: "", title: "The Green podcast" },

                                    ].map((val, index) => {
                                        return (
                                            <div
                                                key={val}
                                                className="mx-5 md:m-2 lg:m-5 bg-tc-blue rounded-full w-40 h-40 overflow-hidden relative"
                                            >
                                                {/* Background Image with Opacity */}
                                                <div
                                                    className="absolute inset-0 bg-center bg-cover opacity-60"
                                                    style={{ backgroundImage: `url(${val.cover})` }}
                                                />

                                                {/* Text on top (keeps full opacity) */}
                                                <div className="relative flex items-center justify-center w-full h-full">
                                                    <p className="text-xs text-white text-center px-2 font-bold mt-10 fonseca-bold">{val.title}</p>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Mission Trips */}
            <section
                ref={ref3}
                className={`py-24 transition-all duration-1000 ${inView3 ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                    }`}
            >
                <div className="max-w-7xl mx-auto px-4">
                    <div className="text-center mb-16">
                        <Globe className="w-12 h-12 text-brand-600 mx-auto mb-4" />
                        <h2 className="font-cormorant text-5xl font-bold">2026 Mission Trips</h2>
                    </div>
                    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                        {[
                            {
                                country: "Ghana",
                                month: "May 2026",
                                image: `${apiData.imgUri2}Trip_Ghana.jpg`
                            },
                            {
                                country: "Malawi",
                                month: "June 2026",
                                image: `${apiData.imgUri2}Trip_Malawi.jpeg`
                            },
                            {
                                country: "Botswana",
                                month: "August 2026",
                                image: `${apiData.imgUri2}Trip_Botswana.jpeg`
                            },
                            {
                                country: "Tanzania",
                                month: "September 2026",
                                image: `${apiData.imgUri2}Trip_Tanzania.jpeg`
                            }
                        ].map((trip, index) => (
                            <div key={index} className="group cursor-pointer">
                                <div className="relative overflow-hidden rounded-xl mb-4">
                                    <img
                                        src={trip.image}
                                        alt={trip.country}
                                        className="w-full h-64 object-cover transform group-hover:scale-110 transition duration-500"
                                    />
                                    <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors"></div>
                                </div>
                                <h3 className="font-cormorant text-2xl font-bold">{trip.country}</h3>
                                <p className="text-gray-600">{trip.month}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};

export default HomeLayout;





{/* <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-6">Welcome to The Transformation Collective</h2>
            <p className="text-lg text-gray-600 mb-8">
            The Transformation Collective exists to empower individuals and
            communities through innovative solutions and transformative leadership,
            equipping them to create lasting change and sustainable impact in every
            sphere of society.
              {/* We equip individuals and communities to create lasting change and sustainable impact in every sphere of society through innovative solutions and transformative leadership. */}
//         </p>
//         <a
//           href="/about"
//           className="text-tc-blue font-semibold hover:text-tc-gold transition duration-300"
//         >
//           Learn More About Us →
//         </a>
//       </div>
//     </div>
//   </section> */}